// CYANNECT-PRICING-FINAL · FAQ copy generated from GET /api/pricing/current so it never drifts from the catalog.
import { cadStr } from "@/lib/pricing";

const n = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;
const addon = (pricing, id) => pricing.addons.find((a) => a.id === id) || {};
const isFree = (p) => p.monthly_cad === "0.00";

export function planPriceLines(pricing) {
  const pr = addon(pricing, "additional_province");
  const sf = addon(pricing, "additional_storefront");
  const bundled = pricing.plans[0]?.addon_storefront_provinces || 3;
  return [
    ...pricing.plans.map((p) => `${p.name} — ${isFree(p) ? "no monthly fee" : `${cadStr(p.monthly_cad)}/month or ${cadStr(p.annual_cad)}/year`} `
      + `(${n(p.storefronts_included, "storefront")}, ${n(p.provinces_included_per_storefront, "province")} per storefront). `
      + `Performance Fee: ${p.fee_pct}% or ${cadStr(p.fee_minimum_cad)} per Verified Sale, whichever is higher.`),
    `Extra province: ${cadStr(pr.monthly_cad)}/month per storefront · Extra storefront: ${cadStr(sf.monthly_cad)}/month (includes up to ${bundled} provinces) · Annual add-ons: ${cadStr(pr.annual_cad)} and ${cadStr(sf.annual_cad)} per year.`,
  ];
}

function planSection(pricing, p, icon) {
  const pr = addon(pricing, "additional_province");
  const sf = addon(pricing, "additional_storefront");
  const annual = (a) => (isFree(p) ? "" : ` (${cadStr(a.annual_cad)}/year on annual billing)`);
  return {
    id: p.id, title: `${p.name} plan`, icon,
    intro: `${p.name} includes ${n(p.storefronts_included, "Storefront")} and up to ${n(p.provinces_included_per_storefront, "Province")} on each included Storefront.`,
    items: [
      { q: `How much does ${p.name} cost?`, a: [
        isFree(p) ? `${p.name}: ${cadStr("0.00")}/month — no subscription fee.` : `${p.name}: ${cadStr(p.monthly_cad)}/month, or ${cadStr(p.annual_cad)}/year (${p.annual_benefit}).`,
        `Performance Fee: ${p.fee_pct}% of the eligible sale or ${cadStr(p.fee_minimum_cad)}, whichever is higher. It is charged only on Verified Sales.`,
        "Prices in CAD, before applicable taxes.",
      ] },
      { q: `How many Storefronts and Provinces are included with ${p.name}?`, a: [
        `${p.name} includes:`, `• ${n(p.storefronts_included, "Storefront")}`, `• Up to ${n(p.provinces_included_per_storefront, "Province")} on each included Storefront`,
      ] },
      { q: `Can my ${p.name} Storefront operate in more provinces?`, a: [
        "Yes.", `Additional province: ${cadStr(pr.monthly_cad)}/month per province, per Storefront${annual(pr)}.`, "", "Province add-ons apply to the specific Storefront.",
      ] },
      { q: `Can ${p.name} merchants add more Storefronts?`, a: [
        "Yes.", `Additional Storefront: ${cadStr(sf.monthly_cad)}/month${annual(sf)}.`, "",
        `Each additional Storefront includes up to ${p.addon_storefront_provinces} Provinces. Extra provinces beyond those are ${cadStr(pr.monthly_cad)}/month each.`,
      ] },
    ],
  };
}

const OVERRIDES = {
  provinces: (pricing, name, s) => {
    const pro = pricing.plans.find((p) => p.id === "growth");
    const k = pro?.provinces_included_per_storefront || 4;
    return { items: s.items.map((it, i) => (i !== 1 ? it : { ...it, a: [
      "No. Province allowances apply PER STOREFRONT.", "", `Example (${name.growth} merchant):`,
      `Storefront A: ${k} provinces`, `Storefront B: ${k} provinces`, "", `Each Storefront independently uses its ${k} included provinces.`,
    ] })) };
  },
  "monthly-addons": (pricing, name) => {
    const pr = addon(pricing, "additional_province");
    const sf = addon(pricing, "additional_storefront");
    return { items: [{ q: "How are add-ons billed if my main plan is monthly?", a: [
      `On ${name.basic}, or if your ${name.starter} or ${name.growth} plan is monthly:`,
      `• Additional Province: ${cadStr(pr.monthly_cad)}/month`, `• Additional Storefront: ${cadStr(sf.monthly_cad)}/month`, "plus applicable taxes.",
    ] }] };
  },
  "annual-addons": (pricing, name, s) => {
    const line = (a) => [`Monthly price: ${cadStr(a.monthly_cad)}`, `Annual price: ${cadStr(a.annual_cad)}/year (15% off 12 months)`, "before applicable taxes."];
    return { items: s.items.map((it, i) => (i === 1 ? { ...it, a: line(addon(pricing, "additional_province")) }
      : i === 2 ? { ...it, a: line(addon(pricing, "additional_storefront")) } : it)) };
  },
  upgrades: (pricing, name) => ({ items: [
    { q: `What happens if I upgrade to ${name.starter} or ${name.growth}?`, a: [
      "The upgrade starts right away. You pay the prorated difference, the new plan's Storefront and Province allowances apply, and new Verified Sales use the new plan's Performance Fee.",
    ] },
    { q: `What happens if I move down to ${name.starter} or ${name.basic}?`, a: [
      "The change takes effect at the end of the period you have already paid for. Cyannect will not automatically delete Storefronts, offers, or historical analytics.", "",
      "If your usage exceeds the new plan's allowances, you may need to:", "• disable excess Storefronts", "• reduce province coverage", "• or purchase the required add-ons", "",
      "before the affected Storefronts/offers can remain active.",
    ] },
  ] }),
};

export function finalFaqSections(sections, pricing) {
  const name = Object.fromEntries(pricing.plans.map((p) => [p.id, p.name]));
  const icons = Object.fromEntries(sections.map((s) => [s.id, s.icon]));
  return sections.flatMap((s) => {
    if (s.id === "starter") return pricing.plans.map((p) => planSection(pricing, p, p.id === "growth" ? icons.growth : s.icon));
    if (s.id === "growth") return [];
    return OVERRIDES[s.id] ? [{ ...s, ...OVERRIDES[s.id](pricing, name, s) }] : [s];
  });
}
